import RateCardTable, { RateCardTableProps } from './RateCardTable';

export type { RateCardTableProps };
export default RateCardTable;
